import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

function BookingRedirect() {
  const { booking_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (booking_id) {
      // Save booking id
      sessionStorage.setItem("booking_id", booking_id);

      // Delay to show spinner briefly
      setTimeout(() => {
        navigate("/login");
      }, 1500);
    }
  }, [booking_id, navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen space-y-4">
      <div className="w-12 h-12 border-4 border-violet-500 border-t-transparent rounded-full animate-spin"></div>
      <p className="text-violet-600 font-medium">Redirecting to login...</p>
    </div>
  );
}

export default BookingRedirect;